const DELIVERY_METHODS = { SMS: 'smsEnabled', EMAIL: 'emailEnabled' };
export { DELIVERY_METHODS };
